import React from 'react'
import styles from './UserProjectsTable.module.scss'
import { t } from 'ttag'

import noDepartments from 'images/illustrations/no-departments.svg'

export const NoJobs = () => {
  return (
    <div className={styles.noProjects}>
      <div className={styles.noProjectsImage}>
        <img src={noDepartments} alt="no jobs" />
      </div>
      <div className={styles.noProjectsLabel}>
        {t`There are no jobs within this department`}. <br />
        {t`You can add jobs in 'Jobs' tab`}.
      </div>
    </div>
  )
}
